import { toast } from 'react-toastify';

import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppMutation, useInvalidateQueries, useLocale } from '../../../../hooks/index';
import ApiService from '../../../../services/api-service.util';

export type UseDeleteTemplateParams = {
  onSuccess?: () => void;
};

export const useDeleteTemplate = ({ onSuccess }: UseDeleteTemplateParams = {}) => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.GET_TEMPLATES);
  const { messagesLocale } = useLocale();

  const { isPending, mutate: deleteTemplate } = useAppMutation<void, Error, string>(
    [QueryKey.GET_TEMPLATES, 'delete'],
    {
      mutationFn: (templateId: string) =>
        ApiService.delete({ endpoint: BackendRoute.TEMPLATES, routePath: [templateId] }),
      onSuccess: () => {
        toast.success(messagesLocale['TEMPLATE_DELETED_SUCCESSFULLY']);
        invalidateQuery();
        onSuccess?.();
      },
    },
  );

  return { deleteTemplate, isPending };
};
